import React, { Component } from "react";
import { TouchableOpacity, View, Text, StyleSheet } from "react-native";
import colors from "../../constants/colors";
import Chip from "./chip";
import ChipOutline from "./chipOutline";
import PropTypes from "prop-types";
import Icon from "react-native-vector-icons/MaterialIcons";
import { MaterialIcons } from "@expo/vector-icons";
import { connect } from "react-redux";
//import { Actions } from "react-native-router-flux";
import Animations from '../animations';
import Moment from 'moment';
import moment from "moment-timezone";
import { BRANDING } from "@env";
import { branding } from "../../api";

class TaskCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contracted: true,
    };

  }

  openClose(){
    const {contracted} = this.state;
    this.setState({contracted: !contracted});    
  }

  showChips(){
    const {contracted} = this.state;

    return (
      <View style={styles.chipsContainer}>

      { !contracted ? 
        <View>
          <Text style={styles.dateLabel}>Due date</Text>
          <Text style={styles.dateText}>{this.props.timeLeft}</Text>
        </View> : null
      }      

      {this.props.frequency != "" && (!this.props.hasChipOutline || !contracted) && (
        <View style={{ flexDirection: "row",width: 100, height: 50 }}>
          <Chip              
            label={this.translateFrequency(this.props.frequency)}
            type={this.props.chipType}            
          ></Chip>
        </View>
      )}           
     
        <View style={{ flexDirection: "row", marginTop: 10 }}>
          {!contracted ? 
              <TouchableOpacity
                style={styles.buttonArchiveClear}
                onPress={this.props.archiveAction}
              >
                <Text style={styles.buttonArchiveText}>Clear</Text>
              </TouchableOpacity>
          :null}
          {!contracted && this.props.confirmOtherOverdues?
                <TouchableOpacity
                style={styles.buttonArchive}
                onPress={this.props.archiveOverduesAction}
              >
                <Text style={styles.buttonArchiveText}>Clear All Overdue Tasks</Text>
              </TouchableOpacity>:null}
          {this.props.hasChipOutline && (
            <ChipOutline
              label={this.props.outlineText}
              type={this.props.chipTypeOutlined}
            ></ChipOutline>
          )}
        </View>
       
      </View>
    );

  }

  translateStatus(name){
    switch(name){
        case "all" : return "All";
        case "in_progress" : return "In Progress";
        case "edit_required" : return "Edit Required";
        case "complete" : return "Complete";
        case "approved" : return "Approved";
        case "archived" : return "Archived";
        case "pending" : return "Pending";
        default : "In Progress";            
      }
  }  

  getTagStyle(name){
    switch(name){
        case "in_progress" : return styles.inProgressTag;
        case "edit_required" : return styles.editRequiredTag;                 
        default : return styles.inProgressTag;
    }
  }

  translateFrequency(val) {
    switch (val) {
      case "Month":
        return "Monthly";
        break;
      case "Year":
        return "Annually";
        break;
      case "Day":
        return "Daily";
        break;
      case "Week":
        return "Weekly";
        break;
      default:
        return "Unknown";
    }
  }

  getStatus(submission){
    if(submission){
      const {status} = submission;
      return <Text style={this.getTagStyle(status)}>{this.translateStatus(status)}</Text>
    }else{
      return <Text style={styles.inProgressTag}>Pending</Text>
    }
  }

  getStatusLabel() {
    const { submission, taskStatus, isLogGroup } = this.props;
    if (submission?.status === "edit_required") return "Edit Required";
    if (isLogGroup) return "Log";
    if (submission?.status) return this.translateStatus(submission.status);
    return this.translateStatus(taskStatus) || "Pending";
  }

  getFormattedDate() {
    const { date } = this.props;
    var dt = new Date();
    var tz = dt.getTimezoneOffset();
    return Moment(date, "YYYY-MM-DD")
      .add(tz / 60, "hours")
      .format(
        BRANDING === "iqops" || branding === "iqops" ? "MMM D, YYYY" : "YYYY-MM-DD"
      );
  }

  getBadgeCount() {
    const { membersTxt, submission } = this.props;
    if (membersTxt && /^\d+$/.test(String(membersTxt).trim())) {
      return String(membersTxt).trim();
    }
    if (submission?.count != null) return String(submission.count);
    if (submission?.pending_count != null) return String(submission.pending_count);
    return null;
  }

  getPilledTasks() {
    const list = this.props.pilledTasks;
    if (!Array.isArray(list)) return [];
    return list.filter((task) => task && typeof task === "object");
  }

  formatRawDate(value) {
    if (!value) return "";
    const parsed = Moment(value);
    if (!parsed.isValid()) return "";
    const tz = new Date().getTimezoneOffset();
    return parsed.add(tz / 60, "hours").format("MMM D, YYYY");
  }

  getDueChip(expirationDate) {
    if (!expirationDate) return null;
    const d = moment.tz(expirationDate, "UTC");
    const dateFuture = moment(moment.tz(d, moment.tz.guess(true)), "YYYY-MM-DD HH:mm:ss");
    const dateNow = moment(new Date(), "YYYY-MM-DD HH:mm:ss");
    const dif = dateFuture.diff(dateNow, "seconds");
    const hours = Math.floor(Math.floor(dif / 60) / 60);
    if (dif < 0) return { label: "Overdue", isOverdue: true, isDueToday: false };
    if (hours < 24) return { label: "Due Today", isOverdue: false, isDueToday: true };
    return null;
  }

  renderPilledTask(task, index) {
    const name = task.name || "";
    const dateText = this.formatRawDate(task.start_date);
    const dateLabel = task.isInvoice ? "Date" : "Start date";
    const status = this.translateStatus(task.submission?.status || task.status) || "Pending";
    const due = this.getDueChip(task.expiration_date);
    return (
      <TouchableOpacity
        key={task._id != null ? String(task._id) : `pilled-${index}`}
        style={styles.iqopsPilledTask}
        activeOpacity={0.85}
        onPress={() => this.props.onOpenTask && this.props.onOpenTask(task)}
      >
        <View style={styles.iqopsPilledBody}>
          <Text style={styles.iqopsStatusLabel}>{status}</Text>
          <Text style={styles.iqopsTitle} numberOfLines={2}>{name}</Text>
          <Text style={styles.iqopsDate}>{dateLabel}: {dateText}</Text>
        </View>
        <View style={styles.iqopsPilledActions}>
          <TouchableOpacity
            style={styles.iqopsPilledClear}
            onPress={(event) => {
              event?.stopPropagation?.();
              this.props.onClearTask && this.props.onClearTask(task);
            }}
          >
            <Text style={styles.buttonArchiveText}>Clear</Text>
          </TouchableOpacity>
          {due ? (
            <View
              style={[
                styles.iqopsPill,
                due.isOverdue && styles.iqopsPillOverdue,
                due.isDueToday && styles.iqopsPillDueToday,
              ]}
            >
              <Text
                style={[
                  styles.iqopsPillText,
                  due.isOverdue && styles.iqopsPillTextOverdue,
                  due.isDueToday && styles.iqopsPillTextDueToday,
                ]}
              >
                {due.label}
              </Text>
            </View>
          ) : (
            <View style={styles.iqopsPillSpacer} />
          )}
          <View style={styles.iqopsChevronSpacer} />
        </View>
      </TouchableOpacity>
    );
  }

  renderIqopsCard() {
    const { contracted } = this.state;
    const {
      isSaving,
      tasksStatus,
      isInvoice,
      hasChipOutline,
      outlineText,
      chipTypeOutlined,
    } = this.props;
    const taskSaving =
      isSaving.get("status") == "saving" || tasksStatus == "loading";
    const locDate = this.getFormattedDate();
    const statusLabel = this.getStatusLabel();
    const badgeCount = this.getBadgeCount();
    const pilledTasks = this.getPilledTasks();
    const pilledCount = pilledTasks.length;
    const isOverdue = chipTypeOutlined === "error";
    const isDueToday = chipTypeOutlined === "dueToday";

    return (
      <View style={[styles.iqopsCard, !contracted && styles.iqopsCardExpanded]}>
      <TouchableOpacity
        disabled={taskSaving}
        onPress={!taskSaving ? this.props.action : null}
        onLongPress={() => this.openClose()}
        delayLongPress={400}
        activeOpacity={0.85}
      >
        <View style={styles.iqopsRow}>
          <View style={styles.iqopsLeft}>
            <Text
              style={[
                styles.iqopsStatusLabel,
                statusLabel === "Edit Required" && styles.iqopsStatusEdit,
              ]}
            >
              {statusLabel}
            </Text>
            <Text style={styles.iqopsTitle} numberOfLines={2}>
              {this.props.taskName}
            </Text>
            <Text style={styles.iqopsDate}>
              {isInvoice ? "Date" : "Start date"}: {locDate}
            </Text>
            {pilledCount > 0 ? (
              <View style={styles.iqopsTaskCount}>
                <Text style={styles.iqopsTaskCountText}>{pilledCount}</Text>
              </View>
            ) : badgeCount ? (
              <View style={styles.iqopsBadge}>
                <Text style={styles.iqopsBadgeText}>{badgeCount}</Text>
              </View>
            ) : null}
            {!contracted ? (
              <View style={styles.iqopsExpandedActions}>
                <Text style={styles.iqopsDate}>Due date: {this.props.timeLeft}</Text>
                <View style={styles.iqopsClearRow}>
                  <TouchableOpacity
                    style={styles.buttonArchiveClear}
                    onPress={this.props.archiveAction}
                  >
                    <Text style={styles.buttonArchiveText}>Clear</Text>
                  </TouchableOpacity>
                  {this.props.confirmOtherOverdues ? (
                    <TouchableOpacity
                      style={styles.buttonArchive}
                      onPress={this.props.archiveOverduesAction}
                    >
                      <Text style={styles.buttonArchiveText}>
                        Clear All Overdue Tasks
                      </Text>
                    </TouchableOpacity>
                  ) : null}
                </View>
              </View>
            ) : null}
          </View>

          <View style={styles.iqopsRight}>
            {hasChipOutline && outlineText ? (
              <View
                style={[
                  styles.iqopsPill,
                  isOverdue && styles.iqopsPillOverdue,
                  isDueToday && styles.iqopsPillDueToday,
                ]}
              >
                <Text
                  style={[
                    styles.iqopsPillText,
                    isOverdue && styles.iqopsPillTextOverdue,
                    isDueToday && styles.iqopsPillTextDueToday,
                  ]}
                >
                  {outlineText === "Due today" ? "Due Today" : outlineText}
                </Text>
              </View>
            ) : (
              <View style={styles.iqopsPillSpacer} />
            )}
            <TouchableOpacity
              style={styles.iqopsChevronBtn}
              onPress={!taskSaving ? this.props.action : null}
              disabled={taskSaving}
            >
              {taskSaving ? (
                <Animations animationfile="loading-dots-gray" />
              ) : (
                <MaterialIcons
                  name="keyboard-arrow-down"
                  size={28}
                  color="#B0B8C4"
                />
              )}
            </TouchableOpacity>
          </View>
        </View>
      </TouchableOpacity>
      {!contracted && pilledCount > 0 ? (
        <View style={styles.iqopsPilledList}>
          {pilledTasks.map((task, index) => this.renderPilledTask(task, index))}
        </View>
      ) : null}
      </View>
    );
  }

  render() {
    if (BRANDING === "iqops" || branding === "iqops") {
      return this.renderIqopsCard();
    }

    const {contracted} = this.state;
    const {isLogGroup,isSaving,taskSelected, tasksStatus,taskStatus, date, membersTxt, isInvoice, taskName} = this.props;
    //const taskSaving = taskSelected._id == this.props._id && (isSaving.get('status') == 'saving' || tasksStatus == 'loading');
    const taskSaving =  isSaving.get('status') == 'saving' || tasksStatus == 'loading';
    const submissionStatus = (typeof this.props.submission != 'undefined') ? this.props.submission.status : 'not_set';
    const submissionMembersTxt = membersTxt ? membersTxt : "";
    //const locDate = new Date(Date.UTC(date)).toLocaleDateString('en-US');
    var dt = new Date();
    var tz = dt.getTimezoneOffset();
    const locDate = Moment(date, "YYYY-MM-DD")
        .add(tz/60, 'hours')
        .format('YYYY-MM-DD');
    //const locDate = date;
    return (
      <TouchableOpacity
        disabled={taskSaving}
        style={{
          padding: 10,
          marginTop: 5,
          marginBottom: 0,
          backgroundColor: "white",
          flexDirection: contracted? "row": "column",              
        }}              
        onPress={()=>this.openClose()}
      >
        <View style={styles.taskTitle}>
          <View style={styles.labelContainer}>
            {
              submissionStatus == 'edit_required' ?
                  <Text>{this.getStatus(this.props.submission)} {submissionMembersTxt ? this.props?.submission?.status != undefined ? `- ${submissionMembersTxt}` : `${submissionMembersTxt}` : ""}</Text>
                : !isLogGroup && <Text style={this.getTagStyle(taskStatus)} >{this.translateStatus(taskStatus)} {submissionMembersTxt ? this.props?.submission?.status != undefined ? `- ${submissionMembersTxt}` : `${submissionMembersTxt}` : ""}</Text>
            }
            {
              isLogGroup && <Text style={styles.groupTag}>Log</Text> 

            }
            <Text style={[styles.taskLabel, styles.taskNormal]}>
              {taskName}
            </Text>
            <Text>
            {isInvoice ? "Date" : "Start date"} : {locDate}
            </Text>
          </View>
        </View>
        <View style={{flexDirection: "row", flexGrow: 1}}>
        <View style={contracted?styles.taskChip: {flexGrow:1}}>
           {this.showChips()}
        </View>
        <TouchableOpacity style={styles.taskAction} onPress={!taskSaving?this.props.action:null}>
                { taskSaving ?
                  <Animations animationfile='loading-dots-gray' />:
                  <View>
                    <MaterialIcons name="chevron-right" size={30} color={colors.blue_gray} />
                  </View>
                }
                
        </TouchableOpacity>
        </View>
      </TouchableOpacity>
    );
  }
}
export default connect(
  (state) => {
    return {
      isSaving: state.forms.getIn(['form'],'status'),
      taskSelected: state.tasks.get('taskSelected'),
      tasksStatus: state.tasks.get('status'),
    };
  },
  (dispatch, props) => {
    return {};
  }
)(TaskCard);

TaskCard.propTypes = {
  taskName: PropTypes.string.isRequired,
  date: PropTypes.string,
  action: PropTypes.func.isRequired,
  frequency: PropTypes.string.isRequired,
  hideArrow: PropTypes.bool,
  chipType: PropTypes.string.isRequired,
  hasChipOutline: PropTypes.bool,
  outlineText: PropTypes.string,
};
const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
  },
  groupTag: {
    fontWeight: "700",
    color: colors.subtitle,
  },
  inProgressTag:{
    fontWeight: "700",
    color: colors.subtitle,
  },
  editRequiredTag:{
    fontWeight: "800",
    color: "#E34537",
  },
  taskTitle: {
    flex:1,
    flexGrow: 50,
    flexDirection: "row",
    alignItems: "center",
  },
  taskChip: {
    width: 100,    
    paddingHorizontal: 5,
    flexDirection: "row",
    alignItems: "center",
  },
  taskAction:{
    width: 30,  
    flexDirection: "row",
    alignItems: "center",
  },
  loadingAnimation: { 
    height: 50,
    width: 50,
  },
  labelContainer: {
    flexGrow: 4,
    flexShrink: 1,
  },
  chipsContainer:{
    flexGrow:1,
  },
  dateLabel: {
    color: colors.description,
    fontSize: 16,
    paddingVertical: 10,
  },
  dateText: {
    color: colors.description,
    fontFamily: "Roboto-Medium",
    fontSize: 18,
    paddingBottom: 10,
  },
  formsLabel: {
    color: colors.blue_gray,
    fontFamily: "Roboto-Italic",
    fontSize: 18,
    paddingBottom: 15,
    paddingTop: 15,
  },
  submissionsLabel: {
    color: colors.blue_gray,
    fontFamily: "Roboto",
    fontSize: 20,
    paddingBottom: 15,
    paddingTop: 15,
  },
  taskLabel: {
    wordBreak: 'break-word',
    flexShrink: 1,
    fontFamily: "Roboto-Bold",
    fontSize: 18,
    paddingBottom: 5,
    paddingTop: 5,
  },
  taskPrimary: {
    color: colors.primary,
  },
  taskNormal: {
    color: colors.secondary,
  },
  taskError: {
    color: colors.error,
  },
  buttonArchive: {
    height: 60,
    width: 120,
    justifyContent: "center",
    borderRadius: 8,
    alignItems: "center",
    backgroundColor: colors.clear,
    marginRight: 20,
  },
  buttonArchiveClear: {
    height: 60,
    width: 60,
    justifyContent: "center",
    borderRadius: 8,
    alignItems: "center",
    backgroundColor: colors.clear,
    marginRight: 20,
  },
  frequencyChip: {
    height: 60,
    width: 120,
    justifyContent: "center",
    borderRadius: 8,
    alignItems: "center",
    backgroundColor: colors.primary,
    marginRight: 20,
  },
  buttonArchiveText: {
    color: colors.userCommandText,
    margin: 5,
    fontSize: 14,
    fontWeight: "bold",
    textAlign: "center",
  },
  buttonText: {
    color: "white",
    fontSize: 20,
    fontWeight: "bold",
    textAlign: "center",
  },
  // iqops card styles
  iqopsCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: 14,
    marginHorizontal: 16,
    marginTop: 10,
    paddingVertical: 14,
    paddingHorizontal: 14,
    borderWidth: 1,
    borderColor: "#E8EEF5",
    shadowColor: "#0b4dad",
    shadowOpacity: 0.06,
    shadowRadius: 8,
    shadowOffset: { width: 0, height: 2 },
    elevation: 2,
  },
  iqopsCardExpanded: {
    paddingBottom: 16,
  },
  iqopsRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  iqopsLeft: {
    flex: 1,
    paddingRight: 10,
  },
  iqopsRight: {
    flexDirection: "row",
    alignItems: "center",
  },
  iqopsStatusLabel: {
    fontSize: 12,
    color: "#9AA3AF",
    fontWeight: "500",
    marginBottom: 4,
  },
  iqopsStatusEdit: {
    color: "#E34537",
    fontWeight: "700",
  },
  iqopsTitle: {
    fontSize: 14,
    fontWeight: "700",
    color: "#1A1A1A",
    marginBottom: 4,
    lineHeight: 22,
  },
  iqopsDate: {
    fontSize: 12,
    color: "#9AA3AF",
  },
  iqopsBadge: {
    marginTop: 8,
    width: 22,
    height: 22,
    borderRadius: 11,
    backgroundColor: "#1A1A1A",
    alignItems: "center",
    justifyContent: "center",
  },
  iqopsBadgeText: {
    color: "#FFFFFF",
    fontSize: 11,
    fontWeight: "700",
  },
  iqopsTaskCount: {
    marginTop: 8,
    width: 28,
    height: 23,
    borderRadius: 6,
    backgroundColor: "#333333",
    alignItems: "center",
    justifyContent: "center",
  },
  iqopsTaskCountText: {
    color: "#ffffff",
    fontSize: 12,
    fontWeight: "700",
  },
  iqopsPilledList: {
    marginTop: 8,
    borderTopWidth: 1,
    borderTopColor: "#E8EEF5",
    paddingTop: 4,
  },
  iqopsPilledTask: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 10,
  },
  iqopsPilledBody: {
    flex: 1,
    paddingRight: 10,
  },
  iqopsPilledActions: {
    flexDirection: "row",
    alignItems: "center",
  },
  iqopsPilledClear: {
    height: 44,
    minWidth: 72,
    paddingHorizontal: 14,
    borderRadius: 10,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.clear,
    marginRight: 12,
  },
  iqopsPill: {
    width: 96,
    height: 44,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: "transparent",
    alignItems: "center",
    justifyContent: "center",
  },
  iqopsPillSpacer: {
    width: 96,
    height: 44,
  },
  iqopsPillOverdue: {
    backgroundColor: "#E53935",
  },
  iqopsPillDueToday: {
    backgroundColor: "#dff7e9",
    borderColor: "#dff7e9",
  },
  iqopsPillText: {
    fontSize: 12,
    fontWeight: "700",
  },
  iqopsPillTextOverdue: {
    color: "#FFFFFF",
  },
  iqopsPillTextDueToday: {
    color: "#16bc4d",
  },
  iqopsChevronBtn: {
    marginLeft: 4,
    width: 28,
    height: 28,
    alignItems: "center",
    justifyContent: "center",
  },
  iqopsChevronSpacer: {
    marginLeft: 4,
    width: 28,
  },
  iqopsExpandedActions: {
    marginTop: 12,
  },
  iqopsClearRow: {
    flexDirection: "row",
    marginTop: 10,
  },
});
